import React from 'react'
import styles from './style'
import propTypes from './prop'
import translator from 'src/translate'
import { Grid, withStyles, Alert } from '@material-ui/core'
import Selection from './selection'
import { cardSelectionAddAction } from 'src/reducers/card/action'
import {
  QuestionFieldNames,
  SelectionFieldNames,
  AnswerItemType,
} from 'src/model/card'

import { Icon } from '@iconify/react'
import { CoreButton } from 'src/components/core'
import { useSelector } from 'react-redux'
const QuestionTestingSingleChoice = props => {
  const { classes, dispatch } = props
  const entity = useSelector(state => state.card.currentCard)
  /**
   *
   */
  const addButtonClickHandler = () => {
    let object = {}
    object[SelectionFieldNames.QUESTION_ID] = entity[QuestionFieldNames.ID]
    object[SelectionFieldNames.STEXT] = ''
    object[SelectionFieldNames.ISCORRECT] = false
    dispatch(cardSelectionAddAction(object, () => {}))
  }

  /**
   *
   */
  const options = () => {
    let item = entity[QuestionFieldNames.SELECTIONS].map((selection, index) => {
      return (
        <Selection
          selection={selection}
          key={selection.id}
          entity={entity}
          index={index}
          dispatch={dispatch}
        />
      )
    })

    return item
  }
  return (
    <React.Fragment>
      <div className={classes.main}>
        {entity[QuestionFieldNames.QUESTION_TYPE] ==
          AnswerItemType.TESTINGSINGLECHOICE &&
          entity[QuestionFieldNames.SELECTIONS].find(
            x => x.isCorrect == true,
          ) === undefined && (
            <Alert severity="info" className={classes.alert}>
              {translator._('taskItem.addQuestion.PleaseSelectCorrectAnswer')}
            </Alert>
          )}

        {entity[QuestionFieldNames.QUESTION_TYPE] ==
          AnswerItemType.TESTINGMULTIPLECHOICE &&
          entity[QuestionFieldNames.SELECTIONS].find(
            x => x.isCorrect == true,
          ) === undefined && (
            <Alert severity="info" className={classes.alert}>
              {translator._('taskItem.addQuestion.PleaseSelectCorrectAnswers')}
            </Alert>
          )}
        {options()}
      </div>

      <Grid
        container
        className={classes.buttonContainer}
        alignItems="center"
        justifyContent={'center'}
      >
        <Grid item className={classes.grid}>
          <CoreButton
            color="primary"
            variant="outlined"
            onClick={addButtonClickHandler}
            className={classes.button}
            fullWidth
            startIcon={<Icon icon="eva:plus-fill" />}
          >
            {translator._('taskItem.addQuestion.answerType.addOption')}
          </CoreButton>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

QuestionTestingSingleChoice.propTypes = propTypes

export default withStyles(styles)(QuestionTestingSingleChoice)
